import * as React from "react";
import { Button, Intent, Tab, Tabs } from "../externals";
import { HourlyPanel } from "./panels/HourlyPanel";
import { MinutesPanel } from "./panels/MinutesPanel";
import { MonthlyPanel } from "./panels/MonthlyPanel";
import { WeeklyPanel } from "./panels/WeeklyPanel";
import { YearlyPanel } from "./panels/YearlyPanel";
import { defMinutesCron, defHourlyCronFirst, defWeeklyCronFirst, defMonthlyCronFirst, defYearlyCronFirst, } from "./defaultCronOptions";
import { sanitizeCron } from "./utils";
export class CronPicker extends React.PureComponent {
    constructor(props) {
        super(props);
        this.startsAtChange = (cron, value) => {
            cron.hours = value[0];
            cron.minutes = value[1];
            this.setState({ actualCron: cron, startsAt: value });
        };
        this.generatePanel = (type) => {
            let panel;
            switch (type) {
                case "minutes":
                    panel = (React.createElement(MinutesPanel, { onChange: (value) => this.setState({ actualCron: value }), cron: this.state.actualCron }));
                    break;
                case "hourly":
                    panel = (React.createElement(HourlyPanel, { onChange: (value) => this.setState({ actualCron: value }), cron: this.state.actualCron }));
                    break;
                case "weekly":
                    panel = (React.createElement(WeeklyPanel, { onChange: (value) => this.setState({ actualCron: value }), startsAt: this.state.startsAt, startsAtChange: (value) => this.startsAtChange(Object.assign({}, this.state.actualCron), value), cron: this.state.actualCron }));
                    break;
                case "monthly":
                    panel = (React.createElement(MonthlyPanel, { onChange: (value) => this.setState({ actualCron: value }), startsAt: this.state.startsAt, startsAtChange: (value) => this.startsAtChange(Object.assign({}, this.state.actualCron), value), cron: this.state.actualCron }));
                    break;
                case "yearly":
                    panel = (React.createElement(YearlyPanel, { onChange: (value) => this.setState({ actualCron: value }), startsAt: this.state.startsAt, startsAtChange: (value) => this.startsAtChange(Object.assign({}, this.state.actualCron), value), cron: this.state.actualCron }));
                    break;
                default:
                    break;
            }
            return panel;
        };
        this.onTabChange = (newTab) => {
            switch (newTab) {
                case "minutesTab":
                    this.setState({ actualCron: defMinutesCron });
                    break;
                case "hourlyTab":
                    this.setState({ actualCron: defHourlyCronFirst });
                    break;
                case "weeklyTab":
                    this.setState({
                        actualCron: Object.assign(Object.assign({}, defWeeklyCronFirst), { minutes: this.state.startsAt[1], hours: this.state.startsAt[0] }),
                    });
                    break;
                case "monthlyTab":
                    this.setState({
                        actualCron: Object.assign(Object.assign({}, defMonthlyCronFirst), { minutes: this.state.startsAt[1], hours: this.state.startsAt[0] }),
                    });
                    break;
                case "yearlyTab":
                    this.setState({
                        actualCron: Object.assign(Object.assign({}, defYearlyCronFirst), { minutes: this.state.startsAt[1], hours: this.state.startsAt[0] }),
                    });
                    break;
            }
        };
        this.state = {
            startsAt: ["12", "0"],
            actualCron: defMinutesCron,
        };
    }
    render() {
        return (React.createElement("div", { className: "tab-container" },
            React.createElement(Tabs, { onChange: (newTab) => {
                    this.onTabChange(newTab.toString());
                }, renderActiveTabPanelOnly: true },
                React.createElement(Tab, { id: "minutesTab", title: "Minutes", panel: this.generatePanel("minutes") }),
                React.createElement(Tab, { id: "hourlyTab", title: "Hourly", panel: this.generatePanel("hourly") }),
                React.createElement(Tab, { id: "weeklyTab", title: "Weekly", panel: this.generatePanel("weekly") }),
                React.createElement(Tab, { id: "monthlyTab", title: "Monthly", panel: this.generatePanel("monthly") }),
                React.createElement(Tab, { id: "yearlyTab", title: "Yearly", panel: this.generatePanel("yearly") })),
            React.createElement("h1", null, sanitizeCron(this.state.actualCron)),
            React.createElement("div", { className: "cron-picker-actions" },
                React.createElement(Button, { text: "Cancel", onClick: () => this.props.onCancel(), style: { marginRight: "15px" } }),
                React.createElement(Button, { text: "Accept", intent: Intent.PRIMARY, onClick: () => {
                        this.props.onAccept(sanitizeCron(this.state.actualCron));
                    } }))));
    }
}
//# sourceMappingURL=CronPicker.js.map